import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useUser } from './_load/UserLoader'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('editUser')
  const user = useUser()

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={1}>
          <Title size="h5" bold>
            {t('changingPassword', { name: user.name })}
          </Title>
        </Col>
      </Grid>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
